import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class CustomFieldsService extends ApiService {
  namespace = "custom-field";
  icon = "Application";
  name = "Custome Fields";
  favicon = "ApplicationForm";
  window = 290;
  Width = 1200;
  DOMAIN = DOMAIN.CUSTOM_FIELD;
  action = "action";
  singular = this.terminology.customFields.singular;
  plural = this.terminology.customFields.plural;
  vowel = this.terminology.customFields.vowel;

  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: "Label",
      icon: AppIcons.TAG,
      field: "number",
    },
    {
      header: "Fieldset",
      icon: AppIcons.APPLICATION_FORM,
      field: "number",
    },
    {
      header: "Date",
      icon: AppIcons.CALENDAR,
      field: "number",
      width: 8,
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Create Fieldset",
      icon: AppIcons.LIST,
      services: -23,
    },
    {
      key: "create",
      label: "Create Field",
      icon: AppIcons.LIST,
    },
  ];
  filterItems = [
    { name: "Fieldset", serviceId: "-23", key: "field", value: "2" },
  ];
  constructor() {
    super("fields");
  }
}
